import apiClient from './apiClient';

export const getReportingApiStatusColor = () => (
  apiClient.get('v1/uptime_status/get_reporting_api_status_color')
);

export const getUpstartStatusColor = () => (
  apiClient.get('v1/uptime_status/get_upstart_status_color')
);
